import { render, staticRenderFns } from "./GbGuideArticle.vue?vue&type=template&id=487181a0"
import script from "./GbGuideArticle.vue?vue&type=script&lang=js"
export * from "./GbGuideArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports